<script>
export default {
  name: 'TextDivider',
  props: {
    text: {
      type: String,
      default: '',
    },
  },
}
</script>

<template>
  <div class="d-flex align-center text-center">
    <v-divider></v-divider>

    <slot id="text-divider-slot">
      <span id="text-divider-span" class="mx-4"> {{ text }} </span>
    </slot>

    <v-divider></v-divider>
  </div>
</template>
